import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, Divider, Box } from "@mui/material";
import { Button, IconButton, Dialog } from "@totalsoft/rocket-ui";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LogValue from "./LogValue";

const ListLog = ({ idx, partnerLog }) => {
  const { t } = useTranslation();

  const [viewValues, setViewValues] = useState(false);

  const handleOpenPopUp = useCallback(() => {
    setViewValues(true);
  }, []);

  const handleClosePopUp = useCallback(() => {
    setViewValues(false);
  }, []);

  return (
    <Grid container spacing={1} sx={{ pt: 1, px: 2 }} id={"partnerList_partnerLog_" + idx}>
      <React.Fragment key={partnerLog.id}>
        <Grid container item xs={12} alignItems={"center"}>
          <Grid item xs={12} md={3} sm={6} id={"partnerList_partnerLog_" + idx + "_modifyDate"}>
            <span> {t("PartnerLog.ModifyDate")}</span>:{" "}
            <span>{t("DATE_FORMAT", { date: { value: partnerLog.modifyDate, format: "DD.MM.YYYY HH:mm:ss" } })}</span>
          </Grid>
          <Grid item xs={12} md={3} sm={6} id={"partnerList_partnerLog_" + idx + "_userName"}>
            <span> {t("PartnerLog.UserName")}</span>: <span>{partnerLog.userName}</span>
          </Grid>
          <Grid item xs={12} md={4} sm={6} id={"partnerList_partnerLog_" + idx + "_changeType"}>
            <span> {t("PartnerLog.ChangeType")}</span>: <span>{partnerLog.changeType}</span>
          </Grid>
          <Grid item xs={12} md={2} sm={6} id={"partnerList_partnerLog_" + idx + "_values"} sx={{ textAlign: "right" }}>
            <IconButton id="partnerList_viewBtn" color="primary" variant="text" size="small" onClick={handleOpenPopUp}>
              <VisibilityIcon sx={{ width: "20px", height: "20px" }} />
            </IconButton>
          </Grid>
        </Grid>
        {
          <Dialog
            onClose={handleClosePopUp}
            aria-labelledby="customized-dialog-title"
            open={viewValues}
            content={<LogValue partnerLogId={partnerLog.id} />}
            maxWidth="md"
            actions={
              <Box mb={1} mx={1}>
                <Button autoFocus onClick={handleClosePopUp} color="primary">
                  {t("PartnerLog.Close")}
                </Button>
              </Box>
            }
            title={t("PartnerLog.ModifiedValues")}
          />
        }
        <Grid item xs={12}>
          <Divider sx={{ my: 1 }} />
        </Grid>
      </React.Fragment>
    </Grid>
  );
};

ListLog.propTypes = {
  idx: PropTypes.number,
  partnerLog: PropTypes.object.isRequired
};

export default ListLog;
